export default __webpack_public_path__ + "static/media/empty-shopping-cart-placeholder.f98cff64.png";